/* eslint-disable react/jsx-no-undef */
import React from "react";

// import { useNavigate } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
import backgroundSuccess from "../../assets/images/register/bg-success.png";
import correct from "../../assets/images/checkmark.png";
import TransparentButton from "../../components/button/TransparentButton";
import yellwSearch from "../../assets/images/icon/yellow-search.png"; //yellow-search.png

export default function LuckyDrawSuccess() {
  const store = useSelector((state) => state.luckyDraw);
  const navigate = useNavigate();
  return (
    <>
      <TopLogo />
      <div
        style={{
          background: `url(${backgroundSuccess}) no-repeat center center fixed`,
          minHeight: "calc(100vh - 60px)",
          padding: "25px",
          backgroundSize: "cover",
        }}
      >
        <img
          className="mx-auto mt-[60px]"
          src={correct}
          alt="logo"
          style={{ width: "52px" }}
        />
        <div className="text-white text-center text-[34px] mt-[10px]">
          ขอบคุณที่ร่วมกิจกรรม
        </div>

        <div className="bg-white pr-[30px]" style={{ borderRadius: "5px" }}>
          <div className="flex justify-start py-[15px]">
            <img
              className="w-[32px] h-[32px]"
              style={{ margin: "auto" }}
              src={yellwSearch}
            />
            <div>
              <p className="text-yellow text-[34px]">
                อยู่ระหว่างตรวจสอบสิทธิ์
              </p>
              <p className="text-blue text-[20px] leading-[11px] ">
                ใช้เวลา 1 -2 วันในการยืนยันสิทธิ์ของคุณ
              </p>
            </div>
          </div>
        </div>

        <br></br>
        <br></br>
        <br></br>

        <p className="text-white text-[24px]">รายละเอียด</p>
        <div className="white-line"></div>
        <div className="mt-[5px] flex justify-between items-start">
          <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
            วันที่ใบเสร็จ:
          </p>
          <p className="text-white text-[16px]">{store["billDate"]}</p>
        </div>
        <div className="flex justify-between items-start">
          <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
            จำนวนสินค้า:
          </p>
          <p className="text-white text-[16px]">{store["total"]}</p>
        </div>
        <div className="flex justify-between items-start">
          <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
            จำนวนสิทธิ์ที่จะได้รับ
          </p>
          <p className="text-white text-[16px]">{store["point"]}</p>
        </div>

        <div className="white-line mt-[5px]"></div>

        <br></br>
        <br></br>
        <br></br>

        <div className="text-center mt-[50px]">
          <div className="my-4">
            <TransparentButton
              variant="contained"
              className="w-[70%]"
              onClick={() => {
                navigate("/lucky-draw");
              }}
            >
              กลับหน้า Lucky Draw
            </TransparentButton>
          </div>
        </div>
      </div>
    </>
  );
}
